export const toCssSize = (value) => (typeof value === 'number' ? `${value}px` : value);

export const LOGO_VARIANTS = ['header', 'login', 'splash', 'loader'];

export const getLogoMarginStyles = (variant, marginTop, marginBottom, marginOnImage = false) => {
  const usesPresetMargins =
    variant === 'splash' || variant === 'loader' || variant === 'login';

  const hasCustomMargin =
    usesPresetMargins && (marginTop != null || marginBottom != null);

  const marginStyle = hasCustomMargin
    ? {
        marginTop: marginTop != null ? toCssSize(marginTop) : undefined,
        marginBottom: marginBottom != null ? toCssSize(marginBottom) : undefined,
      }
    : undefined;

  return {
    hasCustomMargin,
    linkMarginStyle: hasCustomMargin && !marginOnImage ? marginStyle : undefined,
    imageMarginStyle: hasCustomMargin && marginOnImage ? marginStyle : undefined,
  };
};
